import React from "react";

const Square = (props)=>{
    return(
        <div onClick={props.onClick} style={{border:"5px solid",height:"100px", width:"100px", display:"flex",justifyContent:"center",alignItems:"center"}}className="sqaure">
            <h1>{props.value}</h1>
        </div>
    )
}

export default Square;


// const Board = () => {

//     const [state, setState] = useState(Array(9).fill(null));
//     const [count,setCount] = useState(0);
//     const[isXTurn, setIsXTurn] = useState(true);

//     const checkWinner = () =>{
//         const winnerLogic= [
//             [0,1,2],
//             [3,4,4],
//             [6,7,8],
//             [0,3,6],
//             [1,4,7],
//             [2,5,8],
//             [0,4,8],
//             [2,4,6],
//         ];
//         for(let logic of winnerLogic){
//             const [a,b,c]=logic;
//             if(state[a]!==null  && state[a] === state[b] && state[b]=== state[c])
//             {
//                 return state[a];
//             }
//         }
//     return false;
//     };

    // const isWinner = checkWinner();

//     const handleClick = (index) =>{
//         const copyState = [...state];
//         var i = count + 1;
//         setCount(i);
//         console.log("Count is " ,count);
//         copyState[index] = isXTurn ? "X":"O";
//         setState(copyState);
//         setIsXTurn(!isXTurn);   
//     };

//     const checkDraw = (board) =>{
//         if(count=== 9){
//         return true;
//     }else{
//         return false;
//     }
// }

//     if(checkWinner() === true  ){
//             alert(`Winner ${checkWinner()}`);
//                 count  = 0;
//             setState(Array(9).fill(null));
//             setState(Square);
//         }
//     if(checkDraw()){
//         alert("Match Draw");
//             setCount(0);
//         setState(Array(9).fill(null));
//         setState(Square);
//     }

//     const handleReset = ()=>{
//         setState(Array(9).fill(null));
//     }
